import { useCallback, useMemo, useState } from 'react';
import Routing from '@bumble/app/Routing';
import AuthVerify from '@bumble/app/components/AuthVerify';
import { LongPingNotifier } from '@bumble/app/components/LongPingNotifier';
import NavBar, { NavBarContext } from '@bumble/app/components/NavBar';
import SideBar from '@bumble/app/components/SideBar';
import { COLORS } from '@bumble/app/theme';
import { Box, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RootPageLayout = () => {
  const theme = useTheme();
  const isLessThanMd = useMediaQuery(theme.breakpoints.down('md'));
  const [showSideBar, setShowSideBar] = useState(true);
  const [pagesHidingContent, setPagesHidingContent] = useState(0);
  const hideNavContent = useCallback(() => {
    setPagesHidingContent((cur) => cur + 1);
    return () => setPagesHidingContent((cur) => cur - 1);
  }, []);
  const contextValue = useMemo(
    () => ({
      hideNavContent,
    }),
    [hideNavContent],
  );
  const hideNavbar = pagesHidingContent > 0;
  const toggleSideBar = useCallback(() => setShowSideBar((cur) => !cur), []);
  const isSideBarOpen = showSideBar && !isLessThanMd;

  return (
    <Box display="flex" sx={{ background: COLORS.WHITE }}>
      <NavBarContext.Provider value={contextValue}>
        {!hideNavbar && <NavBar showSideBar={isSideBarOpen} {...{ hideNavbar, toggleSideBar }} />}
        {!hideNavbar && <SideBar showSideBar={isSideBarOpen} {...{ hideNavbar }} />}
        <Box
          component="main"
          sx={{
            ...(!hideNavbar && {
              borderRadius: '8px 8px 0px 0px',
              padding: '12px 12px 0',
              maxWidth: `calc(100% - ${isSideBarOpen ? '260px' : '80px'})`,
              transition: theme.transitions.create('all', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
            }),
            width: '100%',
            flex: '1 1 100%',
          }}
        >
          {!hideNavbar && <Toolbar />}
          <Routing />
        </Box>
      </NavBarContext.Provider>
      <AuthVerify />
      <LongPingNotifier />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Box>
  );
};

export default RootPageLayout;
